import Message from './message';
export default class GroupMessage extends Message {
    fire(groupId, traits, options) {
        this.call({
            groupId,
            traits,
            apiMethod: 'group',
        }, options);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3JvdXAtbWVzc2FnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jZHAvbWVzc2FnZXMvZ3JvdXAtbWVzc2FnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLE9BQU8sTUFBTSxXQUFXLENBQUM7QUFHaEMsTUFBTSxDQUFDLE9BQU8sT0FBTyxZQUFhLFNBQVEsT0FBMEI7SUFDbEUsSUFBSSxDQUNGLE9BQWUsRUFDZixNQUFlLEVBQ2YsT0FBb0M7UUFFcEMsSUFBSSxDQUFDLElBQUksQ0FDUDtZQUNFLE9BQU87WUFDUCxNQUFNO1lBQ04sU0FBUyxFQUFFLE9BQU87U0FDbkIsRUFDRCxPQUFPLENBQ1IsQ0FBQztJQUNKLENBQUM7Q0FDRiJ9